import { withJsonFormsCellProps, withTranslateProps } from '@jsonforms/react'
import { DependentSelectControl } from './DependentSelectControl'

export default withJsonFormsCellProps(
    withTranslateProps(DependentSelectControl)
)
